const API_TYPE_SESSION_KEY = "apiType"
const MERITCO_SERVICES_DOMAIN = "meritco-services.com"

function normalizeApiType(value) {
  return value === "1" ? "1" : "0"
}

function getApiTypeFromHostname(hostname = window.location.hostname) {
  const normalizedHostname = hostname.trim().toLowerCase()
  const isMeritcoServicesDomain =
    normalizedHostname === MERITCO_SERVICES_DOMAIN ||
    normalizedHostname.endsWith(`.${MERITCO_SERVICES_DOMAIN}`)

  return isMeritcoServicesDomain ? "1" : null
}

function getApiTypeFromUrl() {
  const currentUrl = new URL(window.location.href)
  const apiTypeFromSearch = currentUrl.searchParams.get(API_TYPE_SESSION_KEY)

  if (apiTypeFromSearch !== null) {
    return apiTypeFromSearch
  }

  const hashQuery = currentUrl.hash.split("?")[1]
  return hashQuery ? new URLSearchParams(hashQuery).get(API_TYPE_SESSION_KEY) : null
}

function initApiTypeSession() {
  const hostnameApiType = getApiTypeFromHostname()
  if (hostnameApiType !== null) {
    sessionStorage.setItem(API_TYPE_SESSION_KEY, hostnameApiType)
    return hostnameApiType
  }

  const currentApiType = sessionStorage.getItem(API_TYPE_SESSION_KEY)
  if (currentApiType !== null) {
    return normalizeApiType(currentApiType)
  }

  const apiType = normalizeApiType(getApiTypeFromUrl())
  sessionStorage.setItem(API_TYPE_SESSION_KEY, apiType)
  return apiType
}

function getApiType() {
  const hostnameApiType = getApiTypeFromHostname()
  if (hostnameApiType !== null) {
    sessionStorage.setItem(API_TYPE_SESSION_KEY, hostnameApiType)
    return hostnameApiType
  }

  const currentApiType = sessionStorage.getItem(API_TYPE_SESSION_KEY)

  if (currentApiType !== null) {
    return normalizeApiType(currentApiType)
  }

  return initApiTypeSession()
}

export {
  API_TYPE_SESSION_KEY,
  getApiType,
  getApiTypeFromUrl,
  initApiTypeSession,
}
